import type { CoreApiToken } from '../../../shared';
import type { SessionId } from '../../services/auth/auth.interface';

export interface State {
    isAuthenticated: boolean;
    isPending: boolean;
    isConnectedAs: boolean;
    token: CoreApiToken | null;
    sessionId: SessionId | null;
}

export const initialState: State = {
    isAuthenticated: false,
    isPending: true,
    isConnectedAs: false,
    token: null,
    sessionId: null
};
